<!-- メイン -->
<div class="main" *ngIf="!isLoading">
  <!-- メインコンテンツ -->
  <div class="main-content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-12">
        <div class="p-fluid p-formgrid p-grid teach-list-item">
          <div class="p-col-12">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-col-12">
                <h6 class="primary-title bold">【新着】 中学校・高校等 (中高生) の希望</h6>
              </div>
            </div>
          </div>
          <div class="p-col-12 list-function">
            <div class="p-fluid p-formgrid p-grid desktop">
              <div class="p-col-10">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 func-item hover" *ngFor="let item of listAgendaSolutions;index as i">
                    <p-card *ngIf="i < 4" (click)="moveC331(item?.agenda_solution_agenda_id)">
                      <div class="p-fluid p-formgrid p-grid func-detail-item center">
                        <div class="func-item-img">
                          <img [src]="item?.agenda_solution_icon_image"
                            [alt]="item?.agenda_solution_title ? item.agenda_solution_title + 'の支援内容アイコン' : '内容未設定の支援内容アイコン'"
                            class="func-img" />
                        </div>
                        <div class="p-col-7 function-item-description separate-line">
                          <span class="func-name text-sub-size letter-spacing-1" [ngClass]="
                              setClassSubId(item?.agenda_solution_desired_subject)
                            ">{{ item?.agenda_solution_desired_subject }}</span>
                          <div class="func-desc mt-1 separate-line">
                            <span class="func-location text-sub-size letter-spacing-1"
                              [pTooltip]="item?.member_municipalities" #mm [tooltipDisabled]="!isOverflow(mm)"
                              showDelay="500" hideDelay="500">{{ item?.member_municipalities }}
                            </span>
                            <span [pTooltip]="item?.member_organization_name" #member_organization_name1
                              [tooltipDisabled]="!isOverflow(member_organization_name1)" showDelay="500" hideDelay="500"
                              class="func-location text-sub-size letter-spacing-1 line-1">{{
                              item?.member_organization_name }}
                            </span>
                            <span [pTooltip]="item?.agenda_solution_oneword_message" #agenda_solution_oneword_message1
                              [tooltipDisabled]="!isOverflow(agenda_solution_oneword_message1)" showDelay="500"
                              hideDelay="500" class="func-location text-sub-size letter-spacing-1 line-1">{{
                              item?.agenda_solution_oneword_message }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </p-card>

                  </div>
                </div>
              </div>

              <div class="p-col-2 btn-move">
                <div class="p-fluid p-formgrid p-grid btn-move-wraper">
                  <div class="p-col-10 btn-move-c231 bg-yellow-bold-color center" (click)="moveC231()">
                    <div class="turn-right">
                      <div class="find-help-text text-white-color center">
                        <h6 class="find-help-text-first letter-spacing-1 bold">
                          {{ getButtonText() }}
                        </h6>
                      </div>
                      <div class="turn-right-icon center">
                        <i class="pi pi-arrow-right text-white-color"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-d-flex p-fluid p-formgrid p-grid mobile p-p-0">
              <div class="p-col-6 func-item hover p-pr-0 p-pt-2" *ngFor="let item of listAgendaSolutions.slice(0,4)">
                <p-card (click)="moveC331(item?.agenda_solution_agenda_id)">
                  <div class="p-fluid p-formgrid p-grid func-detail-item">
                    <p-avatar [image]="item?.agenda_solution_icon_image" size="large" shape="circle">
                    </p-avatar>

                    <div class="p-col-7 function-item-description separate-line">
                      <span class="func-name text-sub-size letter-spacing-1" [ngClass]="
                          setClassSubId(item?.agenda_solution_desired_subject)
                        ">{{ removeParentheses(item?.agenda_solution_desired_subject) }}</span>
                      <div class="func-desc mt-1 separate-line">
                        <span [pTooltip]="item?.member_municipalities" #member_municipalities1
                          [tooltipDisabled]="!isOverflow(member_municipalities1)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1 line-1">{{ item?.member_municipalities
                          }}
                        </span>
                        <span [pTooltip]="item?.member_organization_name" #member_organization_name1
                          [tooltipDisabled]="!isOverflow(member_organization_name1)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1 line-1">{{ item?.member_organization_name
                          }}
                        </span>
                        <span [pTooltip]="item?.agenda_solution_oneword_message" #agenda_solution_oneword_message1
                          [tooltipDisabled]="!isOverflow(agenda_solution_oneword_message1)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1 line-1">{{ item?.agenda_solution_oneword_message
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </p-card>
              </div>
              <div class="p-col-6 btn-move p-pr-0 p-pt-2">
                <div class="p-fluid p-formgrid p-grid btn-move-wraper">
                  <div class="p-col-10 btn-move-c231 bg-yellow-bold-color center" (click)="moveC231()">
                    <div class="turn-right">
                      <div class="find-help-text text-white-color center">
                        <h6 class="find-help-text-first letter-spacing-1 bold">
                          {{ getButtonText() }}
                          <div class="turn-right-icon">
                            <i class="pi pi-arrow-right text-white-color"></i>
                          </div>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="p-fluid p-formgrid p-grid need-list-item">
          <div class="p-col-12">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-col-12">
                <h6 class="primary-title bold">【新着】 保育所・幼稚園等 (乳幼児) の希望</h6>
              </div>
            </div>
          </div>
          <div class="p-col-12 list-function desktop">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-col-10">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 func-item hover" *ngFor="let item of listAgendaNeeds; index as i">
                    <p-card *ngIf="i < 4" (click)="moveC341(item?.agenda_need_agenda_id)">
                      <div class="p-fluid p-formgrid p-grid func-detail-item center">
                        <div class="func-item-img">
                          <img [src]="item?.agenda_need_icon_image"
                            [alt]="item?.agenda_need_title ? item.agenda_need_title + 'の依頼内容アイコン' : '内容未設定の依頼内容アイコン'"
                            class="func-img" />
                        </div>

                        <div class="p-col-7 function-item-description separate-line">
                          <span class="func-name text-sub-size letter-spacing-1" [ngClass]="
                              setClassSubId(item?.member_class_sub_id)
                            ">{{ removeParentheses(item?.member_class_sub_id) }}</span>
                          <div class="func-desc mt-1 separate-line">
                            <span class="func-location text-sub-size letter-spacing-1"
                              [pTooltip]="item?.member_municipalities" #mm [tooltipDisabled]="!isOverflow(mm)"
                              showDelay="500" hideDelay="500">{{ item?.member_municipalities }}
                            </span>
                            <span [pTooltip]="item?.member_organization_name" #member_organization_name2
                              [tooltipDisabled]="!isOverflow(member_organization_name2)" showDelay="500" hideDelay="500"
                              class="func-location text-sub-size letter-spacing-1  line-1">{{
                              item?.member_organization_name }}
                            </span>
                            <span [pTooltip]="item?.agenda_need_oneword_message" #agenda_need_oneword_message
                              [tooltipDisabled]="!isOverflow(agenda_need_oneword_message)" showDelay="500"
                              hideDelay="500" class="func-location text-sub-size letter-spacing-1  line-1">{{
                              item?.agenda_need_oneword_message }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </p-card>
                  </div>
                </div>
              </div>

              <div class="p-col-2 btn-move">
                <div class="p-fluid p-formgrid p-grid btn-move-wraper">
                  <div class="p-col-10 btn-move-c231 bg-yellow-bold-color center" (click)="moveC241()">
                    <div class="turn-right">
                      <div class="find-help-text text-white-color center">
                        <h6 class="find-help-text-first letter-spacing-1 bold">
                          {{ getButtonText() }}
                        </h6>
                      </div>
                      <div class="turn-right-icon center">
                        <i class="pi pi-arrow-right text-white-color"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12 p-d-flex list-function mobile">
            <div class="p-col-12 p-fluid p-formgrid p-grid p-p-0">
              <div class="p-col-6 func-item hover p-pr-0 p-pt-2" *ngFor="let item of listAgendaNeeds.slice(0,4)">
                <p-card (click)="moveC341(item?.agenda_need_agenda_id)">
                  <div class="p-fluid p-formgrid p-grid func-detail-item center">
                    <div class="func-item-img">
                      <p-avatar [image]="item?.agenda_need_icon_image" size="large" shape="circle">
                      </p-avatar>

                    </div>

                    <div class="p-col-7 function-item-description separate-line">
                      <span class="func-name text-sub-size letter-spacing-1" [ngClass]="
                              setClassSubId(item?.member_class_sub_id)
                            ">{{ removeParentheses(item?.member_class_sub_id) }}</span>
                      <div class="func-desc mt-1 separate-line">
                        <span [pTooltip]="item?.member_municipalities" #member_municipalities2
                          [tooltipDisabled]="!isOverflow(member_municipalities2)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1  line-1">
                          {{ item?.member_municipalities}}
                        </span>
                        <span [pTooltip]="item?.member_organization_name" #member_organization_name2
                          [tooltipDisabled]="!isOverflow(member_organization_name2)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1  line-1">{{ item?.member_organization_name
                          }}
                        </span>
                        <span [pTooltip]="item?.agenda_need_oneword_message" #agenda_need_oneword_message
                          [tooltipDisabled]="!isOverflow(agenda_need_oneword_message)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1  line-1">{{ item?.agenda_need_oneword_message
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </p-card>
              </div>
              <div class="p-col-6 btn-move p-pr-0 p-pt-2">
                <div class="p-fluid p-formgrid p-grid btn-move-wraper">
                  <div class="p-col-10 btn-move-c231 bg-yellow-bold-color center" (click)="moveC241()">
                    <div class="turn-right">
                      <div class="find-help-text text-white-color center">
                        <h6 class="find-help-text-first letter-spacing-1 bold">
                          {{ getButtonText() }}
                          <div class="turn-right-icon">
                            <i class="pi pi-arrow-right text-white-color"></i>
                          </div>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="p-fluid p-formgrid p-grid need-list-item" *ngIf="roleAuth == 9">
          <div class="p-col-12">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-col-12">
                <h6 class="primary-title bold">【新着】 相談 (マッチング後)</h6>
              </div>
            </div>
          </div>
          <div class="p-col-12 list-function desktop">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-col-10">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 func-item hover" *ngFor="let item of listConsultations; index as i">
                    <p-card *ngIf="i < 4" (click)= "openConsultationDialog(item)">
                      <div class="p-fluid p-formgrid p-grid func-detail-item center">
                        <div class="func-item-img">
                          <img [src]="item?.consultation_icon_image"
                            [alt]=""
                            class="func-img" />
                        </div>

                        <div class="p-col-7 function-item-description separate-line">
                          <span
                            *ngIf="item?.consultation_match_type === '1'; else otherType"
                            class="func-name text-sub-size letter-spacing-1"
                            [ngClass]="setClassSubId()"
                          >
                            {{ removeParentheses(item?.consultation_class_sub_id) }}
                          </span>
                          <ng-template #otherType>
                            <span
                              *ngIf="item?.consultation_match_type === '2'"
                              class="func-name text-sub-size letter-spacing-1"
                              [ngClass]="setClassSubId()"
                            >
                              {{ removeParentheses(item?.consultation_desired_subject) }}
                            </span>
                          </ng-template>
                          <div class="func-desc mt-1 separate-line">
                            <span class="func-location text-sub-size letter-spacing-1  line-1"
                              [pTooltip]="item?.consultation_municipalities" #tt [tooltipDisabled]="!isOverflow(tt)"
                              showDelay="500" hideDelay="500">{{ item?.consultation_municipalities }}
                            </span>
                            <span [pTooltip]="item?.consultation_registered_organization" #consultation_registered_organization2
                              [tooltipDisabled]="!isOverflow(consultation_registered_organization2)" showDelay="500" hideDelay="500"
                              class="func-location text-sub-size letter-spacing-1  line-1">{{
                              item?.consultation_registered_organization }}
                            </span>
                            <span [pTooltip]="item?.consultation_oneword_message" #consultation_oneword_message2
                              [tooltipDisabled]="!isOverflow(consultation_oneword_message2)" showDelay="500" hideDelay="500"
                              class="func-location text-sub-size letter-spacing-1  line-1">{{
                              item?.consultation_oneword_message }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </p-card>
                  </div>
                </div>
              </div>

              <div class="p-col-2 btn-move">
                <div class="p-fluid p-formgrid p-grid btn-move-wraper">
                  <div class="p-col-10 btn-move-c231 bg-yellow-bold-color center" (click)="moveM701()">
                    <div class="turn-right">
                      <div class="find-help-text text-white-color center">
                        <h6 class="find-help-text-first letter-spacing-1 bold">
                          {{ getButtonText() }}
                        </h6>
                      </div>
                      <div class="turn-right-icon center">
                        <i class="pi pi-arrow-right text-white-color"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-d-flex list-function mobile">
            <div class="p-col-12 p-fluid p-formgrid p-grid p-p-0">
              <div class="p-col-6 func-item hover p-pr-0 p-pt-2" *ngFor="let item of listConsultations.slice(0,4)">
                <p-card (click)= "openConsultationDialog(item)">
                  <div class="p-fluid p-formgrid p-grid func-detail-item center">
                    <div class="func-item-img">
                      <p-avatar [image]="item?.consultation_icon_image" size="large" shape="circle">
                      </p-avatar>

                    </div>

                    <div class="p-col-7 function-item-description separate-line">
                      <span
                            *ngIf="item?.consultation_match_type === '1'; else otherType"
                            class="func-name text-sub-size letter-spacing-1"
                            [ngClass]="setClassSubId()"
                          >
                            {{ removeParentheses(item?.consultation_class_sub_id) }}
                          </span>
                          <ng-template #otherType>
                            <span
                              *ngIf="item?.consultation_match_type === '2'"
                              class="func-name text-sub-size letter-spacing-1"
                              [ngClass]="setClassSubId()"
                            >
                              {{ removeParentheses(item?.consultation_desired_subject) }}
                            </span>
                          </ng-template>
                      <div class="func-desc mt-1 separate-line">
                        <span [pTooltip]="item?.consultation_municipalities" #consultation_municipalities2
                          [tooltipDisabled]="!isOverflow(consultation_municipalities2)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1  line-1">
                          {{ item?.consultation_municipalities}}
                        </span>
                        <span [pTooltip]="item?.consultation_registered_organization" #consultation_registered_organization2
                          [tooltipDisabled]="!isOverflow(consultation_registered_organization2)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1  line-1">{{ item?.consultation_registered_organization
                          }}
                        </span>
                        <span [pTooltip]="item?.consultation_oneword_message" #consultation_oneword_message
                          [tooltipDisabled]="!isOverflow(consultation_oneword_message)" showDelay="500" hideDelay="500"
                          class="func-location text-sub-size letter-spacing-1  line-1">{{ item?.consultation_oneword_message
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </p-card>
              </div>
              <div class="p-col-6 btn-move p-pr-0 p-pt-2">
                <div class="p-fluid p-formgrid p-grid btn-move-wraper">
                  <div class="p-col-10 btn-move-c231 bg-yellow-bold-color center" (click)="moveM701()">
                    <div class="turn-right">
                      <div class="find-help-text text-white-color center">
                        <h6 class="find-help-text-first letter-spacing-1 bold">
                          {{ getButtonText() }}
                          <div class="turn-right-icon">
                            <i class="pi pi-arrow-right text-white-color"></i>
                          </div>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-fluid p-formgrid p-grid p-col-12 p-d-flex list-status">
        <span class="title-new-status bold">お知らせ</span>
        <div class="card notification-container">
          <ng-container *ngFor="let notice of listNotice">
            <div class="notification pointer" [routerLink]="['/pages/platform/e002/'+ notice?.information_id]">
              <div class="date">
                <ul class="bp">
                  <li>
                    {{ notice?.publishe_start }}
                  </li>
                </ul>
              </div>
              <div class="message">
                {{ notice?.title }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="p-fluid p-formgrid p-grid p-col-12 p-d-flex list-status" *ngIf="roleAuth == 1 || roleAuth == 2 || roleAuth == 9">
        <span class="p-col-12 title-new-status bold manual">ふれあい体験関連資料</span>
        <div class="p-col-12 manual-header bold">
          <span class="manual-header-text">【ふれあい体験実践マニュアル・動画】</span>
        </div>
        <div class="p-col-12 manual-wording">
          <a class="manual-wording-text" href="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB/01%E4%B8%AD%E9%AB%98%E7%94%9F%E3%81%A8%E4%B9%B3%E5%B9%BC%E5%85%90%E3%81%AE%E7%9B%B4%E6%8E%A5%E7%9A%84%E3%81%AA%E3%81%B5%E3%82%8C%E3%81%82%E3%81%84%E4%BD%93%E9%A8%93%E5%AE%9F%E8%B7%B5%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB.pdf" target="_blank">
            ・01 中高生と乳幼児の直接的なふれあい体験実践マニュアル
          </a>
        </div>
        <div class="p-col-12 manual-wording">
          <a class="manual-wording-text" href="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB/02-1%E5%AE%9F%E6%96%BD%E8%A6%81%E9%A0%85%EF%BC%88%E3%81%B2%E3%81%AA%E5%BD%A2%EF%BC%89%E3%80%90A%E3%80%91%E4%BF%9D%E8%82%B2%E6%89%80%E3%83%BB%E5%B9%BC%E7%A8%9A%E5%9C%92%E7%AD%89%E3%81%A7%E5%AE%9F%E6%96%BD%E3%81%99%E3%82%8B%E3%83%91%E3%82%BF%E3%83%BC%E3%83%B3.docx">
            ・02-1 実施要項（ひな形）【A】保育所・幼稚園等で実施するパターン
          </a>
        </div>
        <div class="p-col-12 manual-wording">
          <a class="manual-wording-text" href="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB/02-2%E5%AE%9F%E6%96%BD%E8%A6%81%E9%A0%85%EF%BC%88%E3%81%B2%E3%81%AA%E5%BD%A2%EF%BC%89%E3%80%90B%E3%80%91%E4%B8%AD%E5%AD%A6%E6%A0%A1%E3%83%BB%E9%AB%98%E6%A0%A1%E7%AD%89%E3%81%A7%E5%AE%9F%E6%96%BD%E3%81%99%E3%82%8B%E3%83%91%E3%82%BF%E3%83%BC%E3%83%B3.docx">
            ・02-2 実施要項（ひな形）【B】中学校・高校等で実施するパターン
          </a>
        </div>
        <div class="p-col-12 manual-video-list">
          <div class="manual-video-item">
            <span class="manual-video-title">■概要紹介</span>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/buqXgZmsprg?si=nh5OQ9HNEfnJ-a7G" title="■概要紹介" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div class="manual-video-item">
            <span class="manual-video-title">■事例A</span>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/1f5316-wYaw?si=bRDHPvw_Srjjqy6m" title="■事例A" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div class="manual-video-item">
            <span class="manual-video-title">■事例B</span>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/SBcaJ4_Z5Uk?si=UTwuusROIG1x3LyU" title="■事例B" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
        <div class="p-col-12 manual-header bold">
          <span class="manual-header-text">【ふれあい体験実施アンケート】</span>
        </div>
        <div class="p-col-12 manual-info">
          <span class="manual-info-text">ふれあい体験の実施時に、以下のアンケートへの回答をお願いします。</span>
        </div>
        <div class="p-col-12 manual-wording">
          <a class="manual-wording-text" href="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/pdf/%E3%81%B5%E3%82%8C%E3%81%82%E3%81%84%E4%BD%93%E9%A8%93%E5%AE%9F%E6%96%BD%E5%BE%8C%E3%82%A2%E3%83%B3%E3%82%B1%E3%83%BC%E3%83%88.pdf" target="_blank">
            ・アンケート依頼文
          </a>
        </div>
      </div>

      <div class="p-fluid p-formgrid p-grid p-col-12 p-d-flex list-status">
        <span class="title-new-status bold">マッチング進捗状況</span>
        <div class="list-sub-new-status">
          <p-checkbox name="status" value="" label="すべて" class="status-select" [(ngModel)]="checkAll"
            (onChange)="checkUncheckAll($event)" aria-label="すべて"></p-checkbox>
          <ng-container *ngFor="let status of statusProgress">
            <p-checkbox name="status" [value]="status.code" [label]="status.name" class="status-select"
              [(ngModel)]="statusValue" (onChange)="searchChatListCondition()"
              aria-label="{{status.name}}"></p-checkbox>
          </ng-container>
        </div>
      </div>

      <div class="p-col-12 table-detail desktop">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-col-12">
            <div class="p-fluid p-formgrid p-grid bold red-color table-header-row">
              <div class="p-col-3">
                <span class="letter-spacing-2">希望内容</span>
              </div>
              <div class="p-col-2" *ngIf="roleAuth == 1 || roleAuth == 2">
                <span class="letter-spacing-2">マッチング先</span>
              </div>
              <div class="p-col-2" *ngIf="roleAuth == 9">
                <span class="letter-spacing-2">マッチング団体</span>
              </div>
              <div class="p-col-2">
                <span class="letter-spacing-2">メッセージ</span>
              </div>
              <div class="p-col-1">
                <span class="letter-spacing-2">ステータス</span>
              </div>
              <div class="p-col-1 p-d-flex p-flex-column">
                <span class="letter-spacing-2">実施日</span>
              </div>
              <div class="p-col-2">
                <span class="letter-spacing-2">メモ</span>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <div class="line-separate"></div>
          </div>
          <ng-container *ngFor="let chat of listChatMypage">
            <div class="p-col-12">
              <div class="line-separate-grey"></div>
            </div>
            <div class="p-col-12 content-detail">
              <div class="p-fluid p-formgrid p-grid center">

                <div class="p-col-3">
                  <div class="p-fluid p-formgrid p-grid first-content">
                    <div class="chat-func-img-container">
                      <img [src]="chat?.icon_image" [alt]="chat?.title ? chat.title + 'のチャットアイコン' : '内容未設定のチャットアイコン'"
                        class="chat-func-img" />
                    </div>

                    <div class="content-detail-first">
                      <span class="func-name text-sub-size letter-spacing-1"
                        [ngClass]="setClassSubId(chat?.member_class_sub_id)" *ngIf="chat?.match_type == '1'">{{ removeParentheses(chat?.member_class_sub_id) }}
                      </span>
                      <span class="func-name text-sub-size letter-spacing-1"
                        [ngClass]="setClassSubId(chat?.member_class_sub_id)" *ngIf="chat?.match_type == '2'">{{ removeParentheses(chat?.desired_subject) }}
                      </span>
                      <span class="desc-detail" [pTooltip]="item?.municipalities" #tt
                        [tooltipDisabled]="!isOverflow(tt)" showDelay="500" hideDelay="500">{{ chat?.municipalities }}
                      </span>
                      <div [pTooltip]="chat?.needs_organization_name" #needs_organization_name
                        [tooltipDisabled]="!isOverflow(needs_organization_name)" showDelay="500" hideDelay="500"
                        class="desc-detail line-1" *ngIf="chat?.match_type == '1'">
                        {{ chat?.needs_organization_name }}
                      </div>
                      <div [pTooltip]="chat?.seeds_organization_name" #seeds_organization_name
                        [tooltipDisabled]="!isOverflow(seeds_organization_name)" showDelay="500" hideDelay="500"
                        class="desc-detail line-1" *ngIf="chat?.match_type == '2'">
                        {{ chat?.seeds_organization_name }}
                      </div>
                      <div (click)="
                          moveScreenByMatchType(chat?.match_id, chat?.match_type, chat?.ns_id)"
                        [pTooltip]="chat?.oneword_message" #oneword_message
                        [tooltipDisabled]="!isOverflow(oneword_message)" showDelay="500" hideDelay="500"
                        class="desc-detail line-1 tooltip-text title-link">
                        {{ chat?.oneword_message }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="p-col-2">
                  <div [pTooltip]="chat?.needs_organization_name" #needs_organization_name
                    [tooltipDisabled]="!isOverflow(needs_organization_name)" showDelay="500" hideDelay="500"
                    class="desc-detail line-1" *ngIf="roleAuth == '1' || roleAuth == '9'">
                    {{ chat?.needs_organization_name }}
                  </div>
                  <div [pTooltip]="chat?.seeds_organization_name" #seeds_organization_name
                    [tooltipDisabled]="!isOverflow(seeds_organization_name)" showDelay="500" hideDelay="500"
                    class="desc-detail line-1" *ngIf="roleAuth == '2' || roleAuth == '9'">
                    {{ chat?.seeds_organization_name }}
                  </div>
                </div>

                <div class="p-col-2">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-9">
                      <div class="second-desc" [ngClass]="{ redMsg: chat?.count_unread !== '0' }">
                        <ng-container *ngIf="
                            chat?.chat_member_id_comment == loginUser.member_id;
                            else memberChatOther
                          ">
                          <span class="meChat"> あなた </span>
                        </ng-container>
                        <ng-template #memberChatOther>
                          <span class="second-location">{{
                            chat?.chat_member_organization_name
                            }}</span>
                        </ng-template>

                        <div class="second-detail item-description-large tooltip-text underline"
                          [pTooltip]="chat?.chat_chat_comment" #tt [tooltipDisabled]="!isOverflow(tt)" showDelay="500"
                          hideDelay="500" *ngIf="chat?.chat_chat_comment !== ''" (click)="moveC601(chat?.match_id)">
                          {{ chat?.chat_chat_comment }}
                        </div>
                      </div>
                    </div>


                    <div class="p-col-3 col-number center">
                      <div class="number" *ngIf="chat.count_unread !== '0'">
                        <ng-container *ngIf="number(chat.count_unread) > 99 ; else norCount">
                          <p-avatar label="99+" shape="circle" styleClass="item-messge-quality"></p-avatar>
                        </ng-container>
                        <ng-template #norCount>
                          <p-avatar [label]="chat.count_unread" shape="circle"
                            styleClass="item-messge-quality"></p-avatar>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="p-col-1 list-dropdown">
                  <ng-container *ngIf="
                      (chat?.match_status && chat?.match_status !== '0') || (chat?.match_status == '0');
                      else elseTemplate
                    ">
                    <div [ngClass]="setClassStatusDropdown(chat.match_status)">
                      <p-dropdown optionLabel="name"
                        [options]="getListStatusChange(chat.match_status, chat?.match_type)" optionValue="code"
                        [(ngModel)]="chat.match_status" (onChange)="changeStatus($event, chat?.match_id)"
                        aria-label="ステータス変更"></p-dropdown>
                    </div>
                  </ng-container>
                  <ng-template #elseTemplate>
                    <div class="statusOther" [ngClass]="setClassStatus(chat?.match_status)">
                      {{ chat?.match_status_name }}
                    </div>
                  </ng-template>
                </div>

                <div class="p-col-1 list-implement-date p-d-flex p-flex-column">
                  <div class="fit-content">
                    <div class="start-date">
                      {{ chat?.start_implementation_date }}
                    </div>
                    <div class="separate">
                      <div class="separate-icon center" *ngIf="chat?.start_implementation_date">
                        〜
                      </div>
                    </div>
                    <div class="end-date">
                      {{ chat?.end_implementation_date }}
                    </div>
                  </div>
                </div>

                <div class="p-col-2 notepad">
                  <div class="notepad-text">
                    <span class="first-text-notepad tooltip-text" [pTooltip]="chat?.memo" #memo
                      [tooltipDisabled]="!isOverflow(memo)" showDelay="500" hideDelay="500">
                      {{ chat?.memo }} </span><br />
                  </div>
                </div>
                <div class="p-col-1 btn-edit-memo">
                  <button pButton type="button" label="更新" class=""
                    (click)="openMemoDialog(chat?.match_id, chat?.memo)"></button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="p-col-12 table-detail mobile">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-col-12 p-p-0">
            <div class="p-fluid p-formgrid p-grid bold red-color table-header-row center ">
              <div class="col-img">

              </div>
              <div class="col-title">
                <span class="letter-spacing-2 center">希望内容</span>
              </div>
              <!-- <div class="col-matching">
                <span class="letter-spacing-2 center">マッチング先</span>
              </div> -->
              <div class="col-msg">
                <span class="letter-spacing-2 center">メッセージ</span>
              </div>
              <div class="col-status">
                <span class="letter-spacing-2 center">ステータス</span>
              </div>
              <div class="col-date">
                <span class="letter-spacing-2 center">実施日</span>
              </div>
              <div class="col-memo">
                <span class="letter-spacing-2 center">メモ</span>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <div class="line-separate"></div>
          </div>
          <ng-container *ngFor="let chat of listChatMypage">
            <div class="p-col-12">
              <div class="line-separate-grey"></div>
            </div>
            <div class="p-col-12 content-detail">
              <div class="p-fluid p-formgrid p-grid center content-detail-row ">
                <div class="col-img">
                  <div class="chat-func-img-container">
                    <img [src]="chat?.icon_image" [alt]="chat?.title ? chat.title + 'のチャットアイコン' : '内容未設定のチャットアイコン'"
                      class="chat-func-img" />

                  </div>
                </div>
                <div class="col-title">
                  <span class="letter-spacing-2 first-content ">
                    <div class="content-detail-first">
                      <span class="func-name text-sub-size letter-spacing-1" [ngClass]="setClassSubId()" *ngIf="chat?.match_type == '1'">{{
                        removeParentheses(chat?.member_class_sub_id) }}
                      </span>
                      <span class="func-name text-sub-size letter-spacing-1" [ngClass]="setClassSubId()" *ngIf="chat?.match_type == '2'">{{
                        removeParentheses(chat?.desired_subject) }}
                      </span>
                      <span class="desc-detail" [pTooltip]="item?.municipalities" #tt
                        [tooltipDisabled]="!isOverflow(tt)" showDelay="500" hideDelay="500">{{ chat?.municipalities }}
                      </span>
                      <div [pTooltip]="chat?.seeds_organization_name" #seeds_organization_name
                        [tooltipDisabled]="!isOverflow(seeds_organization_name)" showDelay="500" hideDelay="500"
                        class="desc-detail line-1" *ngIf="roleAuth == '1' || roleAuth == '9'">
                        {{ chat?.seeds_organization_name }}
                      </div>
                      <div [pTooltip]="chat?.needs_organization_name" #needs_organization_name
                        [tooltipDisabled]="!isOverflow(needs_organization_name)" showDelay="500" hideDelay="500"
                        class="desc-detail line-1" *ngIf="roleAuth == '2' || roleAuth == '9'">
                        {{ chat?.needs_organization_name }}
                      </div>
                      <span (click)="
                          moveScreenByMatchType(chat?.match_id, chat?.match_type, chat?.ns_id)
                        " class="desc-detail tooltip-text title-link" [pTooltip]="item?.oneword_message" #tt
                        [tooltipDisabled]="!isOverflow(tt)" showDelay="500" hideDelay="500">{{ chat?.oneword_message }}
                      </span>
                    </div>
                  </span>
                </div>
                <!-- <div class="col-matching">
                  <div [pTooltip]="chat?.needs_organization_name" #needs_organization_name
                    [tooltipDisabled]="!isOverflow(needs_organization_name)" showDelay="500" hideDelay="500"
                    class="desc-detail line-1" *ngIf="roleAuth == '1' || roleAuth == '9'">
                    {{ chat?.needs_organization_name }}
                  </div>
                  <div [pTooltip]="chat?.seeds_organization_name" #seeds_organization_name
                    [tooltipDisabled]="!isOverflow(seeds_organization_name)" showDelay="500" hideDelay="500"
                    class="desc-detail line-1" *ngIf="roleAuth == '2' || roleAuth == '9'">
                    {{ chat?.seeds_organization_name }}
                  </div>
                </div> -->
                <div (click)="moveC601(chat?.match_id)" class="col-msg center">
                  <i [ngClass]="{ redMsg: chat?.count_unread !== '0' }" class="pi pi-comment message-text-mobile"></i>
                </div>
                <div class="col-status">
                  <span class="letter-spacing-2 center">
                    <ng-container *ngIf="
                        (chat?.match_status && chat?.match_status !== '0') || (chat?.match_status == '0');
                        else elseTemplate
                      ">
                      <div [ngClass]="setClassStatusDropdown(chat.match_status)">
                        <p-dropdown optionLabel="name"
                          [options]="getListStatusChange(chat.match_status, chat?.match_type)" optionValue="code"
                          [(ngModel)]="chat.match_status" (onChange)="changeStatus($event, chat?.match_id)"
                          aria-label="ステータス変更"></p-dropdown>
                      </div>
                    </ng-container>
                    <ng-template #elseTemplate>
                      <div class="statusOther" [ngClass]="setClassStatus(chat?.match_status)">
                        {{ chat?.match_status_name }}
                      </div>
                    </ng-template>
                  </span>
                </div>
                <div class="col-date list-implement-date p-d-flex p-flex-column p-jc-center">
                  <div class="fit-content">
                    <div class="start-date">
                      {{ chat?.start_implementation_date }}
                    </div>
                    <div class="separate">
                      <div class="separate-icon center" *ngIf="chat?.start_implementation_date">
                        〜
                      </div>
                    </div>
                    <div class="end-date">
                      {{ chat?.end_implementation_date }}
                    </div>
                  </div>
                </div>
                <div class="col-memo">
                  <span (click)="openMemoDialog(chat?.match_id, chat?.memo)">
                    <i class="pi pi-book"></i>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<app-confirm-reject-match-dialog (reject)="cancelConfirm($event)" (isSuccess)="changeStatusSuccess($event)"
  (error)="searchChatListCondition()" (fail)="searchChatListCondition()"></app-confirm-reject-match-dialog>
<!-- Toastメッセージ表示 -->
<p-toast position="top-center"></p-toast>
<app-c331-dialog *ngIf="isShowDialogC331" (returnStatusDialogC331)="closeDialogC331($event)" [matchId]="matchId"
  [agendaId]="agendaId" (reloadData)="searchChatListCondition()"></app-c331-dialog>
<app-c341-dialog *ngIf="isShowDialogC341" (returnStatusDialogC341)="closeDialogC341($event)" [matchId]="matchId"
  (reloadData)="searchChatListCondition()"></app-c341-dialog>
<app-memo-dialog (returnMemoDialog)="closeMemoDialog($event)">
</app-memo-dialog>
<app-consultation-dialog>
</app-consultation-dialog>